import { cn } from "@/lib/utils";
import earlyAdopterBadge from "@/assets/early-adopter-badge.jpg";

interface BadgeType {
  id: string;
  name: string;
  description: string;
  earned_at: string;
}

interface BadgeProps {
  badge: BadgeType;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function Badge({ badge, size = "md", className }: BadgeProps) {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12", 
    lg: "w-16 h-16"
  };

  const getBadgeImage = (badgeId: string) => {
    switch (badgeId) {
      case "early_adopter":
        return earlyAdopterBadge;
      default:
        return earlyAdopterBadge;
    }
  };

  return (
    <div className={cn("relative group", className)}>
      <img
        src={getBadgeImage(badge.id)}
        alt={badge.name}
        className={cn(
          "rounded-full object-cover border-2 border-primary/20 hover:border-primary/40 transition-all duration-300 hover:scale-105",
          sizeClasses[size]
        )}
        title={badge.description}
      />
      
      {/* Tooltip */}
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-popover text-popover-foreground text-xs rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10 border">
        <div className="font-medium">{badge.name}</div>
        <div className="text-muted-foreground">{badge.description}</div>
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-popover"></div>
      </div>
    </div>
  );
}